<header class="header-container">
  <div class="logo-container" (click)="navigateHome()">
    <img [src]="brand.logoHeader" class="brand-logo-header" alt="Logo" />
  </div>
  <div class="user">
    <div class="header-shortcuts">
      <button
        type="button"
        class="header-dash"
        *ngIf="podeVerDashboardPatio"
        (click)="irDashboardPatio()"
      >
        Dashboard Pátio
      </button>
      <button
        type="button"
        class="header-dash"
        *ngIf="podeVerDashboardServicos"
        (click)="irDashboardServicos()"
      >
        Dashboard Serviço
      </button>
      <button
        type="button"
        class="header-dash"
        *ngIf="podeVerDashboardFinanceiro"
        (click)="irDashboardFinanceiro()"
      >
        Dashboard Financeiro
      </button>
    </div>
    <div class="user-image">
      <img src="assets/icon-person.png" />
    </div>
    <div class="user-info">
      <span class="user-name">{{ getNome() }}</span>
    </div>
    <span class="logout" (click)="logout()">
      <img src="assets/logout-v2.svg" />
      <span>Sair</span>
    </span>
  </div>
</header>
